import React from "react";
import NiceModal, { useModal } from "@ebay/nice-modal-react"
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import SideModal from '/src/components/modal/SideModal/SideModal'
import useModalHelper from "/src/components/modal/hooks/useModalHelper";
import Form from "/src/components/form/Form";
import Field from '/src/components/UI/Field/Field';
import TextInput from '/src/components/UI/TextField/TextInput';
import InputRange from '/src/components/UI/InputRange/InputRange';
import ButtonAction from "/src/components/UI/Button/Button";
import StatementBlock from "./StatementBlock";
import StatementModalBody from "./StatementModalBody"
import "./StatementModal.css"
import "/src/assets/css/polices.css";
import { getNameTypeByType } from "../../../data/types/StatementColumnTypes";
import { configureRowStatement } from "../../../configureRowStatement";
import statementService from "../../../services/statementService";
import WorksheetModalBody from "./WorksheetModalBody"
const StatementModal = NiceModal.create(({ dataset, title, data }) => {
    const modal = useModal();

    const { onClose } = useModalHelper(modal);
   
    return (
        <SideModal name="statement_edit_modal" id={modal.id} autoClose="true" onClose={onClose}>
            <div>
                <div className="button-leave" id="close_modal_container" onClick={() => onClose({ idIconModal: "close_modal_container" })}>
                    <i id="close_modal" className="fa fa-times" aria-hidden="true"></i>
                </div>
            </div>
            {dataset.dataset_type_id == 3 ?
                <WorksheetModalBody data={data} title={title} dataset={dataset}></WorksheetModalBody>
                :
                <StatementModalBody data={data} title={title} dataset={dataset}></StatementModalBody>
            }

        </SideModal >
    )
});

export default StatementModal;